export function useAddableWorkflows(
  client,
  clientWorkflows,
  workflows,
  searchValue = ""
) {
  const options = [];
  const clientCurrentWorkflows = new Set(
    client.workflows
      .map((wf) => {
        return clientWorkflows[wf];
      })
      .filter((wf) => {
        return wf && !wf.completed && !wf.archived;
      })
      .map((wf) => {
        return wf.workflowId;
      })
  );

  Object.values(workflows).forEach((workflow) => {
    if (
      (!clientCurrentWorkflows.has(workflow.id) ||
        workflow.options?.multipleTimePerClient) &&
      workflow.name
        .toLocaleLowerCase()
        .includes(searchValue?.toLocaleLowerCase())
    ) {
      options.push({
        value: workflow.id,
        key: workflow.id,
        text: workflow.name,
      });
    }
  });

  return { options: options, isEmpty: options.length === 0 };
}

export default useAddableWorkflows;
